import * as React from 'react';
import { useState } from 'react';
import { cn } from '@/lib/utils';
import * as Icons from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export function FloatingField({
  label,
  type = 'text',
  value,
  onChange,
  error,
  success,
  className,
  required,
  onWheel,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const hasValue = value != null && String(value).length > 0;
  const isActive = focused || hasValue;

  return (
    <div className={cn('relative', className)}>
      <div className={cn(
        'relative rounded-md border bg-background transition-all duration-200',
        focused && 'ring-2 ring-ring ring-offset-0',
        error && 'border-destructive',
        success && 'border-success'
      )}>
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onWheel={(e) => {
            if (type === 'number') {
              e.currentTarget.blur();
              e.preventDefault();
            }
            onWheel?.(e);
          }}
          className="w-full px-3 pt-6 pb-2 bg-transparent outline-none text-sm"
          placeholder=" "
          {...props}
        />
        <label
          className={cn(
            'absolute left-3 transition-all duration-200 pointer-events-none text-muted-foreground',
            isActive
              ? 'top-1.5 text-xs'
              : 'top-1/2 -translate-y-1/2 text-sm'
          )}
        >
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
        <AnimatePresence>
          {success && (
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              className="absolute right-3 top-1/2 -translate-y-1/2"
            >
              <Icons.Check className="h-4 w-4 text-success" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      {error && (
        <p className="text-xs text-destructive mt-1">{error}</p>
      )}
    </div>
  );
}